import { useGroundingStore } from 'modules/Grounding/store/useGroundingStore'
import { Col, Row } from 'react-bootstrap'
import { useGlobalStore } from 'store/useGlobalStore'
import { formatShortContext } from 'utils/stringUtils'
import shallow from 'zustand/shallow'
import {
  StyledGroundInformation,
  StyledVehicleDetailDivider,
  StyledVehicleDetailText
} from './GroundingVehicleDetails.styled'
import { normalizeCurrencySymbol } from 'utils/currencyUtils'
import { setCustomClick } from 'utils/analyticsUtils'

const GroundingVehicleDetails = () => {
  const [groundingData] = useGroundingStore((state) => [state.groundingData], shallow)
  const [getSystemSettings, getLocalText] = useGlobalStore((state) => [state.getSystemSetting, state.getLocalText])
  const hideLesseeName = Number(getSystemSettings('HIDE_LESSEE_NAME_FROM_GROUNDING_SCREEN')) ?? 0
  const hideLesseeAddress = Number(getSystemSettings('HIDE_LESSEE_ADDRESS_FROM_GROUNDING_SCREEN')) ?? 0
  const receivingDealershipPhoneVisibility =
    Number(getSystemSettings('DISPLAY_RECEIVING_DEALERSHIP_PHONE_SECTION')) ?? 0
  const gradeLabel = getLocalText('GradeLabel', 'Grade')

  const computedPurchasePriceString = (purchasePrice: string) => {
    if (purchasePrice && purchasePrice !== '') {
      groundingData.residualPrice = groundingData?.purchasePrice
      groundingData.residualPriceString = purchasePrice
      if (groundingData?.purchasePriceString && groundingData?.selectedDisposition) {
        const selectedCompaign = groundingData?.Campaigns.find(
          (campaign) => campaign.ID === groundingData?.SelectedCampaignId
        )
        if (groundingData?.SelectedCampaignId === 0) return purchasePrice
        else if (selectedCompaign !== undefined && groundingData?.SelectedCampaign.IsPullAhead)
          return groundingData?.residualPriceString
        else return purchasePrice
      }
      return purchasePrice
    }
  }
  return (
    <StyledGroundInformation>
      <StyledVehicleDetailDivider>
        <label>{'Vehicle Details'}</label>
      </StyledVehicleDetailDivider>
      <Row className="mt-3">
        {groundingData?.conditionAlert !== undefined && groundingData?.conditionAlert !== '' && (
          <div>
            <span className="vehicle-cost alert-info condition-tag">CONDITION REPORT PRESENT </span>
          </div>
        )}

        {groundingData?.purchasePriceString !== undefined &&
          groundingData?.purchasePriceString !== null &&
          groundingData?.purchasePriceString !== '$0' &&
          groundingData?.purchasePriceString !== '' && (
            <Col md={3} lg={3}>
              <div className="vehicle-cost alert-info price-tag">
                {computedPurchasePriceString(normalizeCurrencySymbol(groundingData?.purchasePriceString) as string)}
              </div>
            </Col>
          )}
      </Row>

      <Row>
        <Col md={3} lg={3}>
          <StyledVehicleDetailText>
            <span>Vehicle Description: </span>
            <a
              href={`vehicle/${groundingData?.vehicleInstanceID}?grounding=true`}
              target="_blank"
              rel="noreferrer"
              onClick={() => setCustomClick('Grounding: VDP')}
            >
              {groundingData?.vehicleDescription}
            </a>
          </StyledVehicleDetailText>
          <StyledVehicleDetailText>
            <span>VIN: </span> {groundingData?.VIN}
          </StyledVehicleDetailText>
        </Col>
        <Col md={3} lg={3}>
          <StyledVehicleDetailText>
            <span>Lease Type: </span> {groundingData?.fleetName}
          </StyledVehicleDetailText>
          <StyledVehicleDetailText>
            <span>Account Number: </span> {groundingData?.accountNumber}
          </StyledVehicleDetailText>
        </Col>
        <Col md={3} lg={3}>
          <StyledVehicleDetailText>
            <span>Maturity Date: </span> {groundingData?.maturityDate}
          </StyledVehicleDetailText>
          {hideLesseeName !== 1 && (
            <StyledVehicleDetailText>
              <span>Lessee Name: </span> {groundingData?.lesseeName}
            </StyledVehicleDetailText>
          )}
        </Col>
        <Col md={3} lg={3}>
          {receivingDealershipPhoneVisibility === 1 && (
            <StyledVehicleDetailText>
              <span>{gradeLabel}: </span> {groundingData?.Grade ? groundingData?.Grade : 'N/A'}
            </StyledVehicleDetailText>
          )}
          {hideLesseeAddress !== 1 && (
            <StyledVehicleDetailText>
              <span>Lessee Address: </span>
              {formatShortContext(
                30,
                groundingData?.lesseeAddress +
                  groundingData?.lesseeAddress2 +
                  ', ' +
                  groundingData?.lesseeCity +
                  ', ' +
                  groundingData?.lesseeState +
                  ' ' +
                  groundingData?.lesseeZip
              ) + '...'}
            </StyledVehicleDetailText>
          )}
        </Col>
      </Row>
    </StyledGroundInformation>
  )
}

export default GroundingVehicleDetails
